import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-youtube-iframes',
  templateUrl: './youtube-iframes.component.html',
  styleUrl: './youtube-iframes.component.scss'
})
export class YoutubeIframesComponent {
  @Input()
  public iframes : SafeHtml[];

  public carouselConfig = {}
}
